import React from "react";
import { LIST_CAR_TYPE } from "utils/const";

export default function CarTierBar({ selectedCarType, onSelectCarType }) {
  const currentCode = selectedCarType?.code || {};

  return (
    <div className="car-insurance__tier-bar">
      <div className="car-insurance__tier-tabs" role="tablist" aria-label="Loại xe ô tô">
        {LIST_CAR_TYPE.map((item, idx) => {
          const isActive =
            currentCode.usePurpose === item.code.usePurpose &&
            currentCode.carInfo === item.code.carInfo;

          // Display short title for tab pill
          let shortTitle = item.name;
          if (item.code.usePurpose === "non_commercial" && item.code.carInfo === 1) {
            shortTitle = "Không kinh doanh";
          } else if (item.code.usePurpose === "commercial" && item.code.carInfo === 1) {
            shortTitle = "Xe kinh doanh";
          } else if (item.code.carInfo === 19) {
            shortTitle = "Xe vừa chở người vừa chở hàng";
          }

          return (
            <button
              key={idx}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`car-insurance__tier-tab${isActive ? " car-insurance__tier-tab--active" : ""}`}
              onClick={() => onSelectCarType(item)}
            >
              {shortTitle}
            </button>
          );
        })}
      </div>
    </div>
  );
}
